module.exports = __webpack_public_path__ + "static/img/Kunlin_LIU.8b57406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Kunlin_LIU.png
// module id = HATb
// module chunks = 1